var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['username', {click: _vm.clickable}, {mod: _vm.isMod}, {dev: _vm.isDev}],on:{"click":function($event){return _vm.viewProfile(_vm.player.uid)}}},[_vm._v(_vm._s(_vm.player ? _vm.player.username || _vm.player.user : ''))])}
var staticRenderFns = []

export { render, staticRenderFns }